import createMapper from "../createMapper"

/**
 * Encodes the query object by converting the `from` property of the `products` object to a `page` property.
 * @example
 * products.from=24 to products.page=1
 * customUrlMappings: [
 *    mapOffsetToPage
 * ]
 *
 * @hidden
 */

export default createMapper<{ from?: number; size?: number }, { page?: number; size?: number }>({
    encode({ from = 0, size, ...rest }) {
        if (!size) return rest
        const page = Math.floor(from / size) + 1
        return { ...rest, page, size }
    },
    decode({ page = 1, size, ...rest }) {
        if (!size) return rest
        const from = (page - 1) * size
        return { ...rest, from, size }
    }
})
